module.exports = __webpack_public_path__ + "img/icon_portrait_report_image_7.bb111e54.png";